import { formatDate } from "../../../components/formatDate";

export const filterBundle = (bundles) => {
  return bundles.map(({ bundleID, createDate, ...rest }) => ({
    id: bundleID,  // Rename 'serviceOfferingID' to 'id'
    bundleID: bundleID,
    createDate: formatDate(createDate),  // Format 'createDate'
    ...rest  // Keep other properties unchanged
  }));
};